// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".local-shadow{background:radial-gradient(48.91% 77.54% at 59.78% 45.32%,rgba(0,0,0,.2) 29.43%,transparent 85.48%),linear-gradient(90.06deg,#402c24 -7.18%,rgba(99,86,54,.67) 33.71%,rgba(125,111,74,.6) 69.02%,rgba(169,151,89,0) 92.75%,hsla(47,52%,66%,0) 102.9%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
